export interface CustomerTestGroup {
  mgmTestGroup: Group;
  onboardingQuestionnaireTestGroup: Group;
}

export enum Group {
  GROUP_A = 'GROUP_A',
  GROUP_B = 'GROUP_B',
}
